// import React, { useState, useEffect } from "react";
// import MenuScreen from "./MenuScreen";
// import LoaderScreen from "./LoaderScreen";
// import ErrorScreen from "./ErrorScreen";
// import NoWatchlistFoundIcon from "../assets/NoWatchListError.png";
// import MarkupGrid from "./MarkupGrid";
// import CustomMarkupGrid from "./CustomMarkupGrid";
// // import { fetchContent } from "../services/api";
// import ModalScreen from "./ModalScreen";
// import DetailsScreen from "./DetailsScreen";
// import { Translate } from "./LanguageChanger";
// import loginimg from "../assets/loginimg.png";
// import solidbackgroundimg from "../assets/solidbackgroundimg.png";
// import logoutIcon from "../assets/Logout-Icon.png";
// import backIcon from "../assets/back-button.png";
// import Wrapper from "./shared/Wrapper";
// import { getlanguagepopular, getViewAllContent } from "./dataManager";
// import { useDebounce } from "../utils/useDebounce";
// import { useContext } from "react";
// import { AppContext } from "../AppContext";

// let resolution = window.RESOLUTION;
// let shoudRefresh;

// const ViewAllScreen = ({
//   navigate,
//   screenName,
//   isLogedIn,
//   ViewAllData = {},
//   FocusHandler,
//   IsLiveEvent,
// }) => {
//   const [state, setState] = useState({
//     isLogedInUser: isLogedIn,
//     loading: false,
//     // watchlistItems: [],
//     watchlistItems: ViewAllData.data,
//     shouldFocusToGrid: true,
//     griddata: null,
//     shouldCloseMenu: true,
//     shouldShowError: false,
//     shouldRender: false,
//     bgColor: "transparent",
//     shouldShowModal: false,
//     errTitle: "",
//     errDescription: "",
//     errIcon: "",
//     button: ["Logout", "Cancel"],
//     iconWdth: "",
//     iconHeight: "",
//     handleLeft: false,
//     isBackButtonSelected: false,
//   });
//   const {
//     isLogedInUser,
//     loading,
//     watchlistItems,
//     shouldFocusToGrid,
//     shouldCloseMenu,
//     shouldShowError,
//     shouldRender,
//     bgColor,
//     griddata,
//     shouldShowModal,
//     errTitle,
//     errDescription,
//     errIcon,
//     button,
//     iconWdth,
//     iconHeight,
//     handleLeft,
//     isBackButtonSelected,
//   } = state;
//   const [screen, setScreen] = useState();
//   const [data, setData] = useState({});
//   const [localPageNumber, setLocalPageNumber] = useState(1);
//   const [saveSourceContext, setSaveSourceContext] = useState();
//   const debouncedPageNumber = useDebounce(localPageNumber, 500);
//   const { sourceContext, setSourceContext } = useContext(AppContext);
//   const navigateToScreen = (screen, data = {}) => {
//     setScreen(screen);
//     setData(data);
//   };
//   const handleRightButton = () => {
//     setState((prevState) => ({
//       ...prevState,
//       shouldFocusToGrid: true,
//       shouldCloseMenu: true,
//     }));
//     MenuScreen.SetFocus(true);
//   };

//   useEffect(() => {
//     if (localPageNumber > 1) {
//       // let playlist_id = ViewAllData.selectedItem.playlist_id;
//       let playlist_name = ViewAllData.playlist_name; // Extract playlist_name
//       // let playlist_type_id = ViewAllData.AppInAppData[ViewAllData.currentRowIndex].playlist_type_id;
//       // let playlist_type = ViewAllData.AppInAppData[ViewAllData.currentRowIndex].playlist_type;

//       // Get data for the new playlist based on playlist_id

//       console.log(
//         "debug 1702 localPageNumber",
//         ViewAllData,
//         ViewAllData?.AppInAppData[0]?.playlist_type_id
//       );

//       let fetchContentPromise;

//       if (
//         ViewAllData?.AppInAppData?.playlist_type_id === 10 ||
//         ViewAllData?.AppInAppData.playlist_type_id === 9
//       ) {
//         fetchContentPromise = getlanguagepopular(
//           ViewAllData.AppInAppData,
//           ViewAllData.selectedItem,
//           localPageNumber
//         );
//       } else {
//         fetchContentPromise = getViewAllContent(
//           ViewAllData.selectedItem,
//           playlist_name,
//           localPageNumber
//         );
//       }

//       fetchContentPromise.then(function (viewAllData) {
//         console.log("debug 1702 fetchContentPromise then", viewAllData);
//         console.log("debug 1702 viewAllData :: ", viewAllData);

//         // Add playlist_name to viewAllData
//         console.log("debug 1702 viewAllData", viewAllData);

//         const newData = [...watchlistItems, ...viewAllData.data];

//         setState((prevState) => ({
//           ...prevState,
//           watchlistItems: newData,
//           loading: false,
//         }));
//       });
//     }
//   }, [debouncedPageNumber]);

//   const handleMenuselection = (selectedMenu) => {
//     switch (selectedMenu) {
//       case "Login":
//         navigate("LoginScreen");
//         break;
//       case "Profile":
//         navigate("ProfileScreen");
//         break;
//       case "Search":
//         navigate("SearchScreen");
//         break;
//       case "Live":
//         navigate("LiveScreen");
//         break;
//       case "LiveEvents":
//         navigate("LiveEventsScreen");
//         break;
//       case "Home":
//         navigate("HomePage");
//         break;
//       case "Watchlist":
//         break;
//       case "Categories":
//         navigate("CategoryScreen");
//         break;
//       case "Settings":
//         navigate("SettingsScreen");
//         break;
//       case "Logout":
//         break;
//       default:
//         break;
//     }
//   };
//   let hasFetchedData = false;
//   let isGridCalled = true;
//   let headers = {};

//   console.log("playlist_name...", ViewAllData);

//   const handleItemSelected = (item) => {
//     setSaveSourceContext(sourceContext);
//     setSourceContext(`${sourceContext}/(${item?.id}/${item?.title})`);
//     console.log("Item selected:", item);
//     navigateToScreen("DetailsScreen", item);
//   };

//   const callBack = () => {
//     console.log("callBack...");
//     navigate("HomePage");
//     //   setState((prevState) => ({
//     //     ...prevState,
//     //     shouldFocusToGrid: false,
//     //     shouldCloseMenu: false,
//     //   }));
//     //   MenuScreen.SetFocus(false);
//   };

//   const handleBack = (screenName) => {
//     console.log("screenName...", screenName, sourceContext);
//     // loadData();
//     setSourceContext(`${saveSourceContext}`);
//     setState((prevState) => ({
//       ...prevState,
//       loading: false,
//       shouldFocusToGrid: true,
//       shouldCloseMenu: true,
//     }));
//     setScreen(screenName);
//   };

//   const modalOKButtonHandler = (action) => {
//     switch (action) {
//       case "Login":
//         navigate("LoginScreen");
//         break;
//       case "Logout":
//         localStorage.removeItem("JWTToken");
//         localStorage.removeItem("userInfo");
//         const getCountry = localStorage.getItem("country");
//         let headers = {
//           iskid: "0",
//           Langid: "1",
//           "Content-Type": "application/json",
//           country: getCountry,
//         };
//         //Promise.all([fetchContent("/V1/logout", "POST", headers)]);
//         MenuScreen.ReseTfocus(4);
//         MenuScreen.SetFocus(true);
//         handleMenuselection("Login");
//         break;
//       case "Exit":
//         // console.log("exit application..");
//         exitApplication();
//         // window.close();
//         break;
//       default:
//         break;
//     }
//   };

//   const exitApplication = () => {
//     // console.log("exitApp...");
//     if (window.tizen) {
//       window.tizen.application.getCurrentApplication().exit();
//     } else {
//       window.close();
//     }
//   };

//   const handleLogout = (p) => {
//     setState((prevState) => ({
//       ...prevState,
//       shouldCloseMenu: true,
//       shouldShowModal: true,
//       errTitle: "Logout",
//       errDescription: "cofirm-logout",
//       errIcon: logoutIcon,
//       iconWdth: "109px",
//       iconHeight: "109px",
//       button: ["Logout", "Cancel"],
//     }));
//     MenuScreen.SetFocus(true);
//   };

//   const handleLogin = (p) => {
//     setState((prevState) => ({
//       ...prevState,
//       shouldCloseMenu: true,
//       shouldShowModal: true,
//       errTitle: "Login to Continue",
//       errDescription: "LoginContinue",
//       errIcon: loginimg,
//       iconWdth: "109px",
//       iconHeight: "109px",
//       button: ["Login", "Cancel"],
//     }));
//     MenuScreen.SetFocus(true);
//   };

//   const handleExit = () => {
//     setState((prevState) => ({
//       ...prevState,
//       shouldCloseMenu: true,
//       shouldShowModal: true,
//       errTitle: "Exit",
//       errDescription: "ExitMsg",
//       errIcon: logoutIcon,
//       iconWdth: "109px",
//       iconHeight: "109px",
//       button: ["Exit", "Cancel"],
//     }));
//     MenuScreen.SetFocus(true);
//   };

//   const modalCANCELButtonHandler = () => {
//     MenuScreen.ReseTfocus(5);
//     // MenuScreen.ReseTfocus(-1);
//     setState((prevState) => ({
//       ...prevState,
//       shouldShowModal: false,
//       shouldCloseMenu: false,
//     }));
//     MenuScreen.SetFocus(false);
//   };

//   shoudRefresh = () => {
//     setState((prevState) => ({
//       ...prevState,
//       shouldRender: true,
//     }));
//   };

//   const handleBackButton = () => {
//     console.log("back to markup view all to list data....");
//     if (!handleLeft) {
//       console.log("callBack(mmmmmmmmmmmmmmmmm)");
//       navigate("HomePage");
//     } else {
//       console.log("mmmmmmmmmmmmmmmmm333333333");
//       // navigate("HomePage");
//       callBack("Back");
//     }
//   };

//   const handleMarkupGridUPButton = () => {
//     console.log("handleMarkupGridUPButton.....");
//     setState((prevState) => ({
//       ...prevState,
//       isBackButtonSelected:true,
//       // shouldFocusToRowList: true,
//       shouldFocusToGrid: false,
//     }));
//   };

//   const handleMarkupGridOKButton = (item) => {
//     navigateToScreen("DetailsScreen", item);
//   };

//   const detailToDetail = (recommendationItem) => {
//     console.log("naveen :: detailToDetail", recommendationItem);
//     // setData(recommendationItem);
//     // setScreen("DetailsScreen")
//     setState((prevState) => ({
//       ...prevState,
//       loading: true,
//     }));
//     navigateToScreen("", recommendationItem);
//     setTimeout(function () {
//       setState((prevState) => ({
//         ...prevState,
//         loading: false,
//       }));
//       navigateToScreen("DetailsScreen", recommendationItem);
//     }, 100);
//   };

//   useEffect(() => {
//     // console.log("1111111111...");
//     if (isLogedInUser) {
//       //   loadData();
//     } else {
//       // console.log("2222222222....");
//       setState((prevState) => ({
//         ...prevState,
//         shouldShowError: false,
//         shouldCloseMenu: false,
//       }));
//       MenuScreen.SetFocus(false);
//     }
//     return () => {
//       // console.log("watchlistScreen...");
//     };
//     // setState((prevState) => ({
//     //   ...prevState,
//     //   shouldFocusToGrid: false,
//     //   shouldCloseMenu: false,
//     //   }));
//     // MenuScreen.SetFocus(false);
//   }, []);

//   if (screen !== "DetailsScreen") {
//     return (
//       //<Translate langKey={'Watchlist'}/>
//       console.log("ViewAllData...", ViewAllData),
//       (
//         <div style={styles.WatchlistScreenContainer}>
//           {loading && <LoaderScreen />}

//           <div style={{ position: "absolute" }}>
//             <Wrapper
//               as="button"
//               style={{
//                 backgroundColor: "transparent",
//                 border: "none",
//                 marginLeft: "3rem",
//                 borderRadius: "1rem",
//                 aspectRatio: "1/1",
//                 cursor: "pointer",
//                 position: "relative",
//                 top: "1rem",
//                 zIndex: "1",
//                 // left: "6rem",
//                 outline: isBackButtonSelected ? "4px solid #EC008C" : "none",
//               }}
//               onClick={(e) => {
//                 handleBackButton();
//                 // handleBack();
//                 // handleClick(null, -2);
//               }}
//             >
//               <img src={backIcon} width={50} height={50} />
//             </Wrapper>
//           </div>

//           <div style={styles.header}>{ViewAllData?.playlist_name}</div>
//           {console.log("ViewAllData?.playlist_name", ViewAllData)}
//           {ViewAllData?.playlist_type_id === 19 ||
//           ViewAllData?.playlist_type_id === 10 ||
//           ViewAllData?.playlist_type_id === 9 ||
//           ViewAllData?.playlist_type === "genres" ? (
//             <div style={styles.contentArea}>
//               <MarkupGrid
//                 items={watchlistItems}
//                 onItemSelected={handleItemSelected}
//                 rowWidth="100%"
//                 rowHeight={300}
//                 columnWidth={resolution === "FHD" ? 215 : 143}
//                 columnHeight={resolution === "FHD" ? 276 : 184}
//                 itemWidth={resolution === "FHD" ? 215 : 143}
//                 itemHeight={resolution === "FHD" ? 276 : 184}
//                 numberOfColumnsEachRow={7}
//                 numberOfDefaultRows={3}
//                 selectionColor={shouldFocusToGrid ? "#fff" : "transparent"}
//                 selectionStyle="border"
//                 gapBetweenColumns={20}
//                 gapBetweenRows={resolution === "FHD" ? 10 : 7}
//                 columnBgColorOrImage="#0000"
//                 rowBgColorOrImage="#0000"
//                 shouldScrollHorizontally={false}
//                 shouldScrollVertically={true}
//                 scrollDuration={300}
//                 GridXCordinate={0}
//                 GridYCordinate={0}
//                 shouldFocus={shouldFocusToGrid}
//                 callBack={callBack}
//                 handleBack={handleBack}
//                 handleLeft={handleLeft}
//                 itemComponentName="SearchWidget"
//                 navigate={navigateToScreen}
//                 pageNumber={localPageNumber}
//                 setPageNumber={setLocalPageNumber}
//               />
//             </div>
//           ) : (
//             <div style={{ ...styles.contentArea, marginLeft: "100px" }}>
//               <CustomMarkupGrid
//                 rowWidth={1802}
//                 rowHeight={358}
//                 gapBetweenRow={35}
//                 columnWidth={228}
//                 columnHeight={291}
//                 gapBetweenColumn={30}
//                 itemWidth={228}
//                 itemHeight={291}
//                 numRows={3} // Default to create only two rows by default
//                 fontSize="32px"
//                 fontColor="#FFFFFF"
//                 selectionStyle="border" // or "zoom"
//                 numColumns={7} // Default number of columns
//                 shouldFocus={shouldFocusToGrid}
//                 data={ViewAllData.data !== null ? ViewAllData.data : []}
//                 marginLeft={0}
//                 marginTop={0}
//                 rowBgColor="#000000"
//                 rowBgImage=""
//                 columnBgImage=""
//                 isLogedIn={isLogedIn}
//                 columnBgColor={shouldFocusToGrid ? "#333333" : "transparent"}
//                 selectionColor={shouldFocusToGrid ? "#fff" : "transparent"}
//                 gapBetweenCatTitleAndItemList={15}
//                 verticalScrollStartIndex={0} // Adjusted to 0
//                 horizontalScrollStartIndex={3}
//                 animationSpeed={100}
//                 callBack={callBack}
//                 handleLeft={handleLeft}
//                 handleBackButton={handleBackButton}
//                 handleMarkupGridUPButton={handleMarkupGridUPButton}
//                 handleMarkupGridOKButton={handleMarkupGridOKButton}
//               />
//             </div>
//           )}

//           <ErrorScreen
//             disply={shouldShowError ? "flex" : "none"}
//             errorIcon={NoWatchlistFoundIcon}
//           />
//         </div>
//       )
//     );
//   } else if (screen === "DetailsScreen") {
//     return (
//       console.log("dasdklfjjjjjjjjjj"),
//       (
//         <DetailsScreen
//           handleBack={handleBack}
//           isLogedIn={isLogedIn}
//           navigate={navigate}
//           data={data}
//           detailToDetail={detailToDetail}
//         />
//       )
//     );
//   }
// };

// const styles = {
//   WatchlistScreenContainer: {
//     display: "flex",
//     flexDirection: "column",
//     background: `url(${solidbackgroundimg})`,
//     // background: "#000037",
//     width: "100vw",
//     height: "100vh",
//     backgroundSize: "cover",
//     backgroundPosition: "center", // Center the background image
//     backgroundRepeat: "no-repeat", // Do not repeat the background image
//     color: "#D0D0D0",
//     fontSize: "18px",
//     overflow: "hidden",
//   },
//   header: {
//     display: "column",
//     width: "95%",
//     overflow: "hidden",
//     marginLeft: "78px",
//     alignItems: "center",
//     textAlign: "center",
//     fontSize: "40px",
//     color: "#FFFFFF",
//     background: "transparent",
//     position: "absolute",
//     paddingTop: "38px",
//   },
//   contentArea: {
//     display: "flex",
//     flexDirection: "column",
//     height: "945px",
//     width: "90vw",
//     marginLeft: "148px",
//     marginTop: "120px",
//     background: "transparent",
//     position: "absolute",
//   },
// };

// ViewAllScreen.Refresh = (focusedIndx) => {
//   shoudRefresh(true);
// };

// export default ViewAllScreen;


import React, { useState, useEffect } from "react";
import MenuScreen from "./MenuScreen";
import LoaderScreen from "./LoaderScreen";
import ErrorScreen from "./ErrorScreen";
import NoWatchlistFoundIcon from "../assets/NoWatchListError.png";
import MarkupGrid from "./MarkupGrid";
import CustomMarkupGrid from "./CustomMarkupGrid";
// import { fetchContent } from "../services/api";
import ModalScreen from "./ModalScreen";
import DetailsScreen from "./DetailsScreen";
import { Translate } from "./LanguageChanger";
import loginimg from "../assets/loginimg.png";
import solidbackgroundimg from "../assets/solidbackgroundimg.png";
import logoutIcon from "../assets/Logout-Icon.png";
import backIcon from "../assets/back-button.png";
import Wrapper from "./shared/Wrapper";
import { getlanguagepopular, getViewAllContent } from "./dataManager";
import { useDebounce } from "../utils/useDebounce";
import { useContext } from "react";
import { AppContext } from "../AppContext";
import HomeDetailsScreen from "../Module/VodDetails/VodDetailScreen";

let resolution = window.RESOLUTION;
let shoudRefresh;

const ViewAllScreen = ({
  navigate,
  screenName,
  isLogedIn,
  ViewAllData = {},
  FocusHandler,
  IsLiveEvent,
}) => {
  const [state, setState] = useState({
    isLogedInUser: isLogedIn,
    loading: false,
    // watchlistItems: [],
    watchlistItems: ViewAllData.data,
    shouldFocusToGrid: true,
    griddata: null,
    shouldCloseMenu: true,
    shouldShowError: false,
    shouldRender: false,
    bgColor: "transparent",
    shouldShowModal: false,
    errTitle: "",
    errDescription: "",
    errIcon: "",
    button: ["Logout", "Cancel"],
    iconWdth: "",
    iconHeight: "",
    handleLeft: false,
    isBackButtonSelected: false,
  });
  const {
    isLogedInUser,
    loading,
    watchlistItems,
    shouldFocusToGrid,
    shouldCloseMenu,
    shouldShowError,
    shouldRender,
    bgColor,
    griddata,
    shouldShowModal,
    errTitle,
    errDescription,
    errIcon,
    button,
    iconWdth,
    iconHeight,
    handleLeft,
    isBackButtonSelected,
  } = state;
  const [screen, setScreen] = useState();
  const [data, setData] = useState({});
  const [localPageNumber, setLocalPageNumber] = useState(1);
  const [saveSourceContext, setSaveSourceContext] = useState();
  const debouncedPageNumber = useDebounce(localPageNumber, 500);
  const { sourceContext, setSourceContext } = useContext(AppContext);
  const navigateToScreen = (screen, data = {}) => {
    setScreen(screen);
    setData(data);
  };
  const handleRightButton = () => {
    setState((prevState) => ({
      ...prevState,
      shouldFocusToGrid: true,
      shouldCloseMenu: true,
    }));
    MenuScreen.SetFocus(true);
  };

  useEffect(() => {
    if (localPageNumber > 1) {
      // let playlist_id = ViewAllData.selectedItem.playlist_id;
      let playlist_name = ViewAllData.playlist_name; // Extract playlist_name
      // let playlist_type_id = ViewAllData.AppInAppData[ViewAllData.currentRowIndex].playlist_type_id;
      // let playlist_type = ViewAllData.AppInAppData[ViewAllData.currentRowIndex].playlist_type;

      // Get data for the new playlist based on playlist_id

      console.log(
        "debug 1702 localPageNumber",
        ViewAllData,
        ViewAllData?.AppInAppData[0]?.playlist_type_id
      );

      let fetchContentPromise;

      if (
        ViewAllData?.AppInAppData?.playlist_type_id === 10 ||
        ViewAllData?.AppInAppData.playlist_type_id === 9
      ) {
        fetchContentPromise = getlanguagepopular(
          ViewAllData.AppInAppData,
          ViewAllData.selectedItem,
          localPageNumber
        );
      } else {
        fetchContentPromise = getViewAllContent(
          ViewAllData.selectedItem,
          playlist_name,
          localPageNumber
        );
      }

      fetchContentPromise.then(function (viewAllData) {
        console.log("debug 1702 fetchContentPromise then", viewAllData);
        console.log("debug 1702 viewAllData :: ", viewAllData);

        // Add playlist_name to viewAllData
        console.log("debug 1702 viewAllData", viewAllData);

        const newData = [...watchlistItems, ...viewAllData.data];

        setState((prevState) => ({
          ...prevState,
          watchlistItems: newData,
          loading: false,
        }));
      });
    }
  }, [debouncedPageNumber]);

  const handleMenuselection = (selectedMenu) => {
    switch (selectedMenu) {
      case "Login":
        navigate("LoginScreen");
        break;
      case "Profile":
        navigate("ProfileScreen");
        break;
      case "Search":
        navigate("SearchScreen");
        break;
      case "Live":
        navigate("LiveScreen");
        break;
      case "LiveEvents":
        navigate("LiveEventsScreen");
        break;
      case "Home":
        navigate("HomePage");
        break;
      case "Watchlist":
        break;
      case "Categories":
        navigate("CategoryScreen");
        break;
      case "Settings":
        navigate("SettingsScreen");
        break;
      case "Logout":
        break;
      default:
        break;
    }
  };
  let hasFetchedData = false;
  let isGridCalled = true;
  let headers = {};

  console.log("playlist_name...", ViewAllData);

  const handleItemSelected = (item) => {
    setSaveSourceContext(sourceContext);
    setSourceContext(`${sourceContext}/(${item?.id}/${item?.title})`);
    console.log("Item selected:", item);
    navigateToScreen("HomeDetailsScreen", item);
  };

  const callBack = () => {
    console.log("callBack...");
    navigate("HomePage");
    //   setState((prevState) => ({
    //     ...prevState,
    //     shouldFocusToGrid: false,
    //     shouldCloseMenu: false,
    //   }));
    //   MenuScreen.SetFocus(false);
  };

  const handleBack = (screenName) => {
    console.log("screenName...", screenName, sourceContext);
    // loadData();
    setSourceContext(`${saveSourceContext}`);
    setState((prevState) => ({
      ...prevState,
      loading: false,
      shouldFocusToGrid: true,
      shouldCloseMenu: true,
    }));
    setScreen(screenName);
  };

  const modalOKButtonHandler = (action) => {
    switch (action) {
      case "Login":
        navigate("LoginScreen");
        break;
      case "Logout":
        localStorage.removeItem("JWTToken");
        localStorage.removeItem("userInfo");
        const getCountry = localStorage.getItem("country");
        let headers = {
          iskid: "0",
          Langid: "1",
          "Content-Type": "application/json",
          country: getCountry,
        };
        //Promise.all([fetchContent("/V1/logout", "POST", headers)]);
        MenuScreen.ReseTfocus(4);
        MenuScreen.SetFocus(true);
        handleMenuselection("Login");
        break;
      case "Exit":
        // console.log("exit application..");
        exitApplication();
        // window.close();
        break;
      default:
        break;
    }
  };

  const exitApplication = () => {
    // console.log("exitApp...");
    if (window.tizen) {
      window.tizen.application.getCurrentApplication().exit();
    } else {
      window.close();
    }
  };

  const handleLogout = (p) => {
    setState((prevState) => ({
      ...prevState,
      shouldCloseMenu: true,
      shouldShowModal: true,
      errTitle: "Logout",
      errDescription: "cofirm-logout",
      errIcon: logoutIcon,
      iconWdth: "109px",
      iconHeight: "109px",
      button: ["Logout", "Cancel"],
    }));
    MenuScreen.SetFocus(true);
  };

  const handleLogin = (p) => {
    setState((prevState) => ({
      ...prevState,
      shouldCloseMenu: true,
      shouldShowModal: true,
      errTitle: "Login to Continue",
      errDescription: "LoginContinue",
      errIcon: loginimg,
      iconWdth: "109px",
      iconHeight: "109px",
      button: ["Login", "Cancel"],
    }));
    MenuScreen.SetFocus(true);
  };

  const handleExit = () => {
    setState((prevState) => ({
      ...prevState,
      shouldCloseMenu: true,
      shouldShowModal: true,
      errTitle: "Exit",
      errDescription: "ExitMsg",
      errIcon: logoutIcon,
      iconWdth: "109px",
      iconHeight: "109px",
      button: ["Exit", "Cancel"],
    }));
    MenuScreen.SetFocus(true);
  };

  const modalCANCELButtonHandler = () => {
    MenuScreen.ReseTfocus(5);
    // MenuScreen.ReseTfocus(-1);
    setState((prevState) => ({
      ...prevState,
      shouldShowModal: false,
      shouldCloseMenu: false,
    }));
    MenuScreen.SetFocus(false);
  };

  shoudRefresh = () => {
    setState((prevState) => ({
      ...prevState,
      shouldRender: true,
    }));
  };

  const handleBackButton = () => {
    console.log("back to markup view all to list data....");
    if (!handleLeft) {
      console.log("callBack(mmmmmmmmmmmmmmmmm)");
      navigate("HomePage");
    } else {
      console.log("mmmmmmmmmmmmmmmmm333333333");
      // navigate("HomePage");
      callBack("Back");
    }
  };

  const handleMarkupGridUPButton = () => {
    console.log("handleMarkupGridUPButton.....");
    setState((prevState) => ({
      ...prevState,
      isBackButtonSelected: true,
      shouldFocusToGrid: false,
    }));
  };

  const handleMarkupGridDownButton = () => {
    console.log("handleMarkupGridDownButton.....");
    setState((prevState) => ({
      ...prevState,
      isBackButtonSelected: false,
      shouldFocusToGrid: true,
    }));
  };

  const handleMarkupGridOKButton = (item) => {
    if(isBackButtonSelected){
      handleBackButton();
      return;
    }
    else
    {navigateToScreen("HomeDetailsScreen", item);}
  };

  const detailToDetail = (recommendationItem) => {
    console.log("naveen :: detailToDetail", recommendationItem);
    // setData(recommendationItem);
    // setScreen("DetailsScreen")
    setState((prevState) => ({
      ...prevState,
      loading: true,
    }));
    navigateToScreen("", recommendationItem);
    setTimeout(function () {
      setState((prevState) => ({
        ...prevState,
        loading: false,
      }));
      navigateToScreen("HomeDetailsScreen", recommendationItem);
    }, 100);
  };

  // Handle key navigation for back button
  const handleBackButtonKeyDown = (e) => {
   
    if (e.key === "ArrowDown") {
      console.log("handlebackbutton....");
      // handleBackButton();
      e.preventDefault();
      setState((prevState) => ({
        ...prevState,
        isBackButtonSelected: false,
        shouldFocusToGrid: true,
      }));
    }
  
  };

  useEffect(() => {
    if (isLogedInUser) {
      // loadData();
    } else {
      setState((prevState) => ({
        ...prevState,
        shouldShowError: false,
        shouldCloseMenu: false,
      }));
      MenuScreen.SetFocus(false);
    }
    return () => {
      // console.log("watchlistScreen...");
    };
  }, []);

  useEffect(() => {
    // Add event listener for back button focus
    if (isBackButtonSelected) {
      const backButton = document.querySelector('[data-back-button="true"]');
      if (backButton) {
        backButton.focus();
      }
    }
  }, [isBackButtonSelected]);
if (screen === "HomeDetailsScreen") {
    return (
      console.log("dasdklfjjjjjjjjjj"),
      (
        <HomeDetailsScreen
          handleBack={handleBack}
          isLogedIn={isLogedIn}
          navigate={navigate}
          data={data}
          detailToDetail={detailToDetail}
        />
      )
    );
  }
 else {
    return (
      console.log("ViewAllData...", ViewAllData),
      (
        <div style={styles.WatchlistScreenContainer}>
          {loading && <LoaderScreen />}

          <div style={{ position: "absolute" }}>
            <Wrapper
              data-back-button="true"
              as="button"
              style={{
                backgroundColor: isBackButtonSelected ? "#333333" : "transparent",
                border: "none",
                marginLeft: "3rem",
                borderRadius: "1rem",
                aspectRatio: "1/1",
                cursor: "pointer",
                position: "relative",
                top: "1rem",
                zIndex: "1",
                outline: isBackButtonSelected ? "4px solid #EC008C" : "none",
              }}
              onClick={(e) => {
                handleBackButton();
              }}
              onKeyDown={handleBackButtonKeyDown}
              tabIndex={isBackButtonSelected ? "0" : "-1"}
            >
              <img src={backIcon} width={50} height={50} />
            </Wrapper>
          </div>

          <div style={styles.header}>{ViewAllData?.playlist_name}</div>
          {console.log("ViewAllData?.playlist_name", ViewAllData)}
          {ViewAllData?.playlist_type_id === 19 ||
          ViewAllData?.playlist_type_id === 10 ||
          ViewAllData?.playlist_type_id === 9 ||
          ViewAllData?.playlist_type === "genres" ? (
            <div style={styles.contentArea}>
              <MarkupGrid
                items={watchlistItems}
                onItemSelected={handleItemSelected}
                rowWidth="100%"
                rowHeight={300}
                columnWidth={resolution === "FHD" ? 215 : 143}
                columnHeight={resolution === "FHD" ? 276 : 184}
                itemWidth={resolution === "FHD" ? 215 : 143}
                itemHeight={resolution === "FHD" ? 276 : 184}
                numberOfColumnsEachRow={7}
                numberOfDefaultRows={3}
                selectionColor={shouldFocusToGrid ? "#fff" : "transparent"}
                selectionStyle="border"
                gapBetweenColumns={20}
                gapBetweenRows={resolution === "FHD" ? 10 : 7}
                columnBgColorOrImage="#0000"
                rowBgColorOrImage="#0000"
                shouldScrollHorizontally={false}
                shouldScrollVertically={true}
                scrollDuration={300}
                GridXCordinate={0}
                GridYCordinate={0}
                shouldFocus={shouldFocusToGrid}
                callBack={callBack}
                handleBack={handleBack}
                handleLeft={handleLeft}
                itemComponentName="SearchWidget"
                navigate={navigateToScreen}
                pageNumber={localPageNumber}
                setPageNumber={setLocalPageNumber}
                onUpButtonPress={handleMarkupGridUPButton}
                onDownButtonPress={handleMarkupGridDownButton}
                screen={"viewallscreen"}
              />
            </div>
          ) : (
            <div style={{ ...styles.contentArea, marginLeft: "100px" }}>
              <CustomMarkupGrid
                screen={"viewallscreen"}
                rowWidth={1802}
                rowHeight={358}
                gapBetweenRow={35}
                columnWidth={228}
                columnHeight={291}
                gapBetweenColumn={30}
                itemWidth={228}
                itemHeight={291}
                numRows={3} // Default to create only two rows by default
                fontSize="32px"
                fontColor="#FFFFFF"
                selectionStyle="border" // or "zoom"
                numColumns={7} // Default number of columns
                shouldFocus={shouldFocusToGrid}
                data={ViewAllData.data !== null ? ViewAllData.data : []}
                marginLeft={0}
                marginTop={0}
                rowBgColor="#000000"
                rowBgImage=""
                columnBgImage=""
                isLogedIn={isLogedIn}
                columnBgColor={shouldFocusToGrid ? "#333333" : "transparent"}
                selectionColor={shouldFocusToGrid ? "#fff" : "transparent"}
                gapBetweenCatTitleAndItemList={15}
                verticalScrollStartIndex={0} // Adjusted to 0
                horizontalScrollStartIndex={3}
                animationSpeed={100}
                callBack={callBack}
                handleLeft={handleLeft}
                handleBackButton={handleBackButton}
                handleMarkupGridUPButton={handleMarkupGridUPButton}
                handleMarkupGridDownButton={handleMarkupGridDownButton}
                handleMarkupGridOKButton={handleMarkupGridOKButton}
                isBackButtonSelected={isBackButtonSelected}
              />
            </div>
          )}

          <ErrorScreen
            disply={shouldShowError ? "flex" : "none"}
            errorIcon={NoWatchlistFoundIcon}
          />
        </div>
      )
    );
  } 
};

const styles = {
  WatchlistScreenContainer: {
    display: "flex",
    flexDirection: "column",
    background: `url(${solidbackgroundimg})`,
    // background: "#000037",
    width: "100vw",
    height: "100vh",
    backgroundSize: "cover",
    backgroundPosition: "center", // Center the background image
    backgroundRepeat: "no-repeat", // Do not repeat the background image
    color: "#D0D0D0",
    fontSize: "18px",
    overflow: "hidden",
  },
  header: {
    display: "column",
    width: "95%",
    overflow: "hidden",
    marginLeft: "78px",
    alignItems: "center",
    textAlign: "center",
    fontSize: "40px",
    color: "#FFFFFF",
    background: "transparent",
    position: "absolute",
    paddingTop: "38px",
  },
  contentArea: {
    display: "flex",
    flexDirection: "column",
    height: "945px",
    width: "90vw",
    marginLeft: "148px",
    marginTop: "120px",
    background: "transparent",
    position: "absolute",
  },
};

ViewAllScreen.Refresh = (focusedIndx) => {
  shoudRefresh(true);
};

export default ViewAllScreen;
